import { trimStartEndSlashes } from "@/shared/utils/url";

import { ApiModules } from "../types";

export const getApiUrl = (module: ApiModules, url: string, isQueryUrl: boolean = false) => {
	const delimiter = isQueryUrl ? "" : "/";
	return `${module}${delimiter}${trimStartEndSlashes(url)}`;
};
